import React, { useEffect, useState } from 'react';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { OverviewTab } from './components/OverviewTab';
import { HowItWorksTab } from './components/HowItWorksTab';
import { AuditTrustTab } from './components/AuditTrustTab';
import { EarlyAccessTab } from './components/EarlyAccessTab';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { TermsOfService } from './pages/TermsOfService';
import { TabId } from './components/TabNavigation';
type Page = 'main' | 'privacy-policy' | 'terms-of-service';
export function App() {
  const [activeTab, setActiveTab] = useState<TabId>('overview');
  const [page, setPage] = useState<Page>('main');
  // Handle URL hash changes
  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash.slice(1);
      if (hash === 'privacy-policy') {
        setPage('privacy-policy');
        return;
      }
      if (hash === 'terms-of-service') {
        setPage('terms-of-service');
        return;
      }
      setPage('main');
      const tabId = hash as TabId;
      if (['overview', 'how-it-works', 'audit-trust', 'early-access'].includes(tabId)) {
        setActiveTab(tabId);
      } else {
        setActiveTab('overview');
        if (!hash) window.history.replaceState(null, '', '#overview');
      }
    };
    handleHashChange();
    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);
  const handleTabChange = (tabId: TabId) => {
    setActiveTab(tabId);
    setPage('main');
    window.location.hash = tabId;
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  const handleNavigateToPage = (targetPage: Page) => {
    setPage(targetPage);
    if (targetPage !== 'main') {
      window.location.hash = targetPage;
    }
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  const handleBackToMain = () => {
    setPage('main');
    window.location.hash = activeTab;
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  if (page === 'privacy-policy') {
    return <div className="min-h-screen flex flex-col bg-white font-sans text-gray-900" data-id="element-0">
        <main className="flex-grow w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-1">
          <PrivacyPolicy onBack={handleBackToMain} data-id="element-2" />
        </main>
        <Footer onNavigate={handleNavigateToPage} data-id="element-3" />
      </div>;
  }
  if (page === 'terms-of-service') {
    return <div className="min-h-screen flex flex-col bg-white font-sans text-gray-900" data-id="element-4">
        <main className="flex-grow w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-5">
          <TermsOfService onBack={handleBackToMain} data-id="element-6" />
        </main>
        <Footer onNavigate={handleNavigateToPage} data-id="element-7" />
      </div>;
  }
  return <div className="min-h-screen flex flex-col bg-white font-sans text-gray-900" data-id="element-8">
      <Header activeTab={activeTab} onTabChange={handleTabChange} data-id="element-9" />
      <main id="main-content" className="flex-grow w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" role="tabpanel" aria-labelledby={`${activeTab}-tab`} data-id="element-10">
        {activeTab === 'overview' && <OverviewTab onNavigate={handleTabChange} data-id="element-11" />}
        {activeTab === 'how-it-works' && <HowItWorksTab data-id="element-12" />}
        {activeTab === 'audit-trust' && <AuditTrustTab data-id="element-13" />}
        {activeTab === 'early-access' && <EarlyAccessTab data-id="element-14" />}
      </main>
      <Footer onNavigate={handleNavigateToPage} data-id="element-15" />
    </div>;
}